import moment from 'moment/min/moment-with-locales';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { DATE_FORMAT_DD_MMM } from '@/helpers/common';
import { prettyFloatMoney } from '@/helpers/utils';
import Dropdown from '@/components/Dropdown';
import { RoundButton } from '@/components/UI/RoundButton';
import { useGetLoanPaymentHistoryByFundraisingId } from '@/query/queries/loan/useGetLoanPaymentHistoryByFundraisingId';
import s from './index.module.scss';

export const RepaymentHistory = ({ fundraisingID, group }) => {
  const { t } = useTranslation('loans');
  const {
    data: paymentHistory,
    hasNextPage,
    fetchNextPage,
  } = useGetLoanPaymentHistoryByFundraisingId(fundraisingID, group);

  const hasPayments = !!paymentHistory?.pages[0]?.total_count;

  return (
    <div className={s.wrapper}>
      <Dropdown
        className={s.dropdown}
        label={
          <h2 className="f-article-accent">
            {t('loan_info.repayment_history')}
          </h2>
        }
      >
        {hasPayments ? (
          <>
            <div className={s.table__wrapper}>
              <div className={s.table__inner}>
                <div className={s.table}>
                  <div className={s.table__thead}>
                    <div className={s.table__thead_col}>
                      {t('loan_info.date')}
                    </div>
                    <div className={s.table__thead_col}>
                      {t('loan_info.amount')}
                    </div>
                    <div className={s.table__thead_col}>
                      {t('loan_info.status')}
                    </div>
                  </div>
                  <div className={s.table__tbody}>
                    {paymentHistory.pages.map(page =>
                      page.list.map((item, idx) => (
                        <div className={s.table__tbody_row} key={idx}>
                          <div className={s.table__tbody_col}>
                            <span className="f-small-regular">
                              {moment(item.created_at)
                                .format(DATE_FORMAT_DD_MMM)
                                .replace('.', '')}
                            </span>
                          </div>
                          <div className={s.table__tbody_col}>
                            <span className="f-small-regular">
                              {prettyFloatMoney(item.amount)}
                            </span>
                          </div>
                          <div
                            className={classnames(
                              s.table__tbody_col,
                              s.description,
                            )}
                          >
                            <span className="f-small-regular">
                              {' '}
                              {item.text}
                            </span>
                          </div>
                        </div>
                      )),
                    )}
                  </div>
                </div>
              </div>
            </div>
            {hasNextPage && (
              <RoundButton
                type="button"
                label={t('load_more')}
                className={s.btn_more}
                onClick={fetchNextPage}
              />
            )}
          </>
        ) : (
          <div className={classnames(s.empty_message, 'f-small-regular')}>
            {t('loan_info.no_repayments_yet')}
          </div>
        )}
      </Dropdown>
    </div>
  );
};
